import { parseClientEnv, type ClientEnv } from './config';
import { toHttpBaseUrl } from './healthProbe';
import { APP_VERSION } from './version';

/** Nombre provisional del producto. */
export const APP_NAME = 'TCG Prototype';

/** Subtitulo de la pantalla inicial. */
export const APP_TAGLINE = 'Technical bootstrap';

/**
 * Estados de conexion previstos.
 *
 * En esta fase solo se usa `Not connected`: la conexion WebSocket todavia no
 * esta implementada.
 */
export const CONNECTION_STATUSES = ['Not connected', 'Connecting', 'Connected'] as const;

export type ConnectionStatus = (typeof CONNECTION_STATUSES)[number];

/** Datos que muestra la pantalla inicial. */
export interface BootstrapInfo {
  readonly appName: string;
  readonly tagline: string;
  readonly version: string;
  /** URL WebSocket del servidor de juego, para la futura conexion Colyseus. */
  readonly serverUrl: string;
  /** Base HTTP del mismo servidor, usada por el health check. */
  readonly serverHttpUrl: string;
  /**
   * Estado de la conexion **de juego** (Colyseus), no del health check. Sigue
   * sin implementarse, asi que se mantiene en `Not connected`.
   */
  readonly connectionStatus: ConnectionStatus;
}

/**
 * Construye la informacion de la pantalla inicial.
 *
 * Funcion pura respecto a `env`, lo que permite probarla sin montar React ni
 * tocar el DOM.
 */
export function createBootstrapInfo(env: ClientEnv = parseClientEnv()): BootstrapInfo {
  return {
    appName: APP_NAME,
    tagline: APP_TAGLINE,
    version: APP_VERSION,
    serverUrl: env.VITE_SERVER_URL,
    serverHttpUrl: env.VITE_SERVER_HTTP_URL ?? toHttpBaseUrl(env.VITE_SERVER_URL),
    connectionStatus: 'Not connected',
  };
}
